<div class="gamedata-download-dialog">
  <div class="dialog-content">
    <div class="dialog-info">
      <div class="info-item" *ngIf="environment">
        <span class="info-label">Environment:</span>
        <span class="info-value environment-badge">{{ environment.toUpperCase() }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">Build Version:</span>
        <span class="info-value build-version">{{ buildVersion }}</span>
      </div>
    </div>

    <div class="button-group">
      <button 
        pButton 
        type="button" 
        label="Full Gamedata" 
        icon="pi pi-download"
        class="p-button-primary full-button"
        (click)="selectFull()">
      </button>
      
      <button 
        pButton 
        type="button" 
        label="Lite Gamedata" 
        icon="pi pi-download"
        class="p-button-secondary lite-button"
        (click)="selectLite()">
      </button>
    </div>
  </div>
</div>

